import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaHandsHelping, FaPeopleCarry, FaBed, FaCalendarCheck, FaPhone, FaEnvelope, FaExclamationCircle, FaBars, FaTimes } from 'react-icons/fa';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    document.body.style.overflow = !isMobileMenuOpen ? 'hidden' : 'auto';
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    document.body.style.overflow = 'auto';
  };

  return (
    <div className="w-full z-50 text-md">
      {/* Top banner - make it single line on mobile */}
      <div className="bg-primary text-white py-2">
        <div className="container overflow-hidden mx-auto px-4 md:px-16">
          <div className="animate-marquee whitespace-nowrap text-sm md:text-base">
            <span className="font-avenir font-bold">New Robust MTA/SIL vacancies now open in South Australia, Queensland and Victoria. <a className="underline" href='/properties'>See Listings</a></span>
          </div>
        </div>
      </div>

      <header className="bg-white shadow-lg w-full">
        <nav className="container mx-auto py-2 md:py-4 flex justify-between items-center px-4 md:px-16" role="navigation">
          {/* Logo section */}
          <Link to="/" className="flex items-center" aria-label="Home">
            <img src="/LC_Logo.png" alt="Livability Care Australia" className="h-16 md:h-24 mr-3" />
          </Link>

          {/* Mobile menu button */}
          <button 
            className="lg:hidden text-primary p-2"
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>

          {/* Desktop Navigation */}
          <div className="hidden font-semibold lg:flex items-center space-x-8">
            <div className="group">
              <button className="link-underline text-primary hover:text-primary-light font-avenir flex items-center">
                About
                <svg className="fill-current h-4 w-4 ml-2 transition-transform duration-200 group-hover:rotate-180" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </button>
              <div className="fixed left-0 right-0 mt-6 invisible group-hover:visible opacity-0 group-hover:opacity-100 bg-white shadow-lg
                            transition-all duration-200 ease-in-out transform -translate-y-1 group-hover:translate-y-0">
                <div className="container mx-auto py-4 px-16">
                  <div className="grid grid-cols-2 gap-6 animate-slideDown">
                    <Link to="/about-us" className="group flex items-center space-x-3 p-4 rounded-xl hover:bg-gray-50 transition-all duration-200">
                      <div>
                        <h3 className="font-bold mb-1 group-hover:text-secondary-green transition-colors duration-200">About Us</h3>
                        <p className="text-sm text-gray-600">Learn about our mission and values</p>
                      </div>
                    </Link>
                    <Link to="/our-team" className="group flex items-center space-x-3 p-4 rounded-xl hover:bg-gray-50 transition-all duration-200">
                      <div>
                        <h3 className="font-bold mb-1 group-hover:text-secondary-green transition-colors duration-200">Our Team</h3>
                        <p className="text-sm text-gray-600">Meet our dedicated professionals</p>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Services dropdown - keep existing Services content */}
            <div className="group">
              <button className="link-underline text-primary hover:text-primary-light font-avenir flex items-center">
                Services
                <svg className="fill-current h-4 w-4 ml-2 transition-transform duration-200 group-hover:rotate-180" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </button>
              <div className="fixed left-0 right-0 mt-6 invisible group-hover:visible opacity-0 group-hover:opacity-100 bg-white shadow-lg
                            transition-all duration-200 ease-in-out transform -translate-y-1 group-hover:translate-y-0">
                <div className="container mx-auto py-8 px-16">
                  <div className="grid grid-cols-1 gap-6 animate-slideDown">
                    <div className="grid grid-cols-3 gap-6">
                    <Link to="/properties" className="group flex items-center space-x-3 p-4 rounded-xl hover:bg-gray-50 transition-all duration-200">
                        <FaExclamationCircle className="text-2xl text-secondary-green group-hover:scale-110 transition-transform duration-200" />
                        <div>
                          <h3 className="font-bold mb-1 group-hover:text-secondary-green transition-colors duration-200">Supported Independent Living</h3>
                          <p className="text-sm text-gray-600">Find available SIL properties</p>
                        </div>
                      </Link>
                      <Link to="/services/inhome-support" className="group flex items-center space-x-3 p-4 rounded-xl hover:bg-gray-50 transition-all duration-200">
                        <FaHandsHelping className="text-2xl text-secondary-green group-hover:scale-110 transition-transform duration-200" />
                        <div>
                          <h3 className="font-bold mb-1 group-hover:text-secondary-green transition-colors duration-200">In-Home Support</h3>
                          <p className="text-sm text-gray-600">Personalised care in the comfort of your home</p>
                        </div>
                      </Link>
                      <Link to="/services/community" className="group flex items-center space-x-3 p-4 rounded-xl hover:bg-gray-50 transition-all duration-200">
                        <FaPeopleCarry className="text-2xl text-secondary-green group-hover:scale-110 transition-transform duration-200" />
                        <div>
                          <h3 className="font-bold mb-1 group-hover:text-secondary-green transition-colors duration-200">Community Participation</h3>
                          <p className="text-sm text-gray-600">Engage in meaningful community activities</p>
                        </div>
                      </Link>
                      <Link to="/services/respite" className="group flex items-center space-x-3 p-4 rounded-xl hover:bg-gray-50 transition-all duration-200">
                        <FaBed className="text-2xl text-secondary-green group-hover:scale-110 transition-transform duration-200" />
                        <div>
                          <h3 className="font-bold mb-1 group-hover:text-secondary-green transition-colors duration-200">Transition & Respite Care</h3>
                          <p className="text-sm text-gray-600">Short-term accommodation and support</p>
                        </div>
                      </Link>
                      <Link to="/properties" className="group flex items-center space-x-3 p-4 rounded-xl hover:bg-gray-50 transition-all duration-200">
                        <FaExclamationCircle className="text-2xl text-secondary-green group-hover:scale-110 transition-transform duration-200" />
                        <div>
                          <h3 className="font-bold mb-1 group-hover:text-secondary-green transition-colors duration-200">Disability Housing Vacancies</h3>
                          <p className="text-sm text-gray-600">Find available SDA and SIL properties</p>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Link to="/sda-homes" className="link-underline text-primary hover:text-primary-light font-avenir">
              SDA Homes
            </Link>

            <div className="group">
              <button className="link-underline text-primary hover:text-primary-light font-avenir flex items-center">
                Resources
                <svg className="fill-current h-4 w-4 ml-2 transition-transform duration-200 group-hover:rotate-180" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </button>
              <div className="fixed left-0 right-0 mt-6 invisible group-hover:visible opacity-0 group-hover:opacity-100 bg-white shadow-lg
                            transition-all duration-200 ease-in-out transform -translate-y-1 group-hover:translate-y-0">
                <div className="container mx-auto py-4 px-16">
                  <div className="grid grid-cols-2 gap-6 animate-slideDown">
                    <Link to="/resources" className="group flex items-center space-x-3 p-4 rounded-xl hover:bg-gray-50 transition-all duration-200">
                      <div>
                        <h3 className="font-bold mb-1 group-hover:text-secondary-green transition-colors duration-200">Resources</h3>
                        <p className="text-sm text-gray-600">Helpful information and guides</p>
                      </div>
                    </Link>
                    <Link to="/news" className="group flex items-center space-x-3 p-4 rounded-xl hover:bg-gray-50 transition-all duration-200">
                      <div>
                        <h3 className="font-bold mb-1 group-hover:text-secondary-green transition-colors duration-200">News</h3>
                        <p className="text-sm text-gray-600">Latest updates and announcements</p>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <Link to="/careers" className="link-underline text-primary hover:text-primary-light font-avenir">
              Careers
            </Link>

            <div className="flex items-center space-x-6 ml-6 border-l pl-6">
              <Link to="/contact" 
                className="flex items-center space-x-2 bg-primary-yellow text-primary hover:bg-opacity-90 font-avenir py-2 px-6 rounded-full hover:text-black transition-colors duration-200">
                
                <span className="font-arial-rounded">Contact Us</span>
              </Link>
            </div>
          </div>

          {/* Mobile Navigation Overlay */}
          <div className={`lg:hidden fixed inset-0 bg-white z-50 transition-transform duration-300 ease-in-out ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}>
            <div className="flex justify-between items-center p-4 border-b">
              <img src="/LC_Logo.png" alt="Livability Care Australia" className="h-16" />
              <button onClick={toggleMobileMenu} className="text-primary p-2">
                <FaTimes size={24} />
              </button>
            </div>
            <div className="p-4 space-y-4">
              <div className="space-y-2">
                <p className="font-bold text-primary">About</p>
                <div className="pl-4 space-y-2">
                  <Link to="/about-us" onClick={closeMobileMenu} className="block py-2 text-gray-600">About Us</Link>
                  <Link to="/our-team" onClick={closeMobileMenu} className="block py-2 text-gray-600">Our Team</Link>
                </div>
              </div>
              
              <div className="space-y-2">
                <p className="font-bold text-primary">Services</p>
                <div className="pl-4 space-y-2">
                <Link to="/properties" onClick={closeMobileMenu} className="block py-2 text-gray-600">
                    <FaExclamationCircle className="inline-block mr-2 text-secondary-green" />
                    Supported Independent Living
                  </Link>
                  <Link to="/services/inhome-support" onClick={closeMobileMenu} className="block py-2 text-gray-600">
                    <FaHandsHelping className="inline-block mr-2 text-secondary-green" />
                    In-Home Support
                  </Link>
                  <Link to="/services/community" onClick={closeMobileMenu} className="block py-2 text-gray-600">
                    <FaPeopleCarry className="inline-block mr-2 text-secondary-green" />
                    Community Participation
                  </Link>
                  <Link to="/services/respite" onClick={closeMobileMenu} className="block py-2 text-gray-600">
                    <FaBed className="inline-block mr-2 text-secondary-green" />
                    Transition & Respite Care
                  </Link>
                  <Link to="/properties" onClick={closeMobileMenu} className="block py-2 text-gray-600">
                    <FaExclamationCircle className="inline-block mr-2 text-secondary-green" />
                    Disability Housing Vacancies
                  </Link>
                  
                </div>
              </div>
              <Link to="/sda-homes" onClick={closeMobileMenu} className="block py-2 text-primary hover:text-primary-light font-avenir">
                SDA Homes
              </Link>
              
              <div className="space-y-2">
                <p className="font-bold text-primary">Resources</p>
                <div className="pl-4 space-y-2">
                  <Link to="/resources" onClick={closeMobileMenu} className="block py-2 text-gray-600">Resources</Link>
                  <Link to="/news" onClick={closeMobileMenu} className="block py-2 text-gray-600">News</Link>
                </div>
              </div>
              
              <Link to="/careers" onClick={closeMobileMenu} className="block py-2 text-primary hover:text-primary-light font-avenir">
                Careers
              </Link>
              
              <div className="pt-4 border-t">
                <Link to="/contact" onClick={closeMobileMenu} className="flex items-center space-x-2 text-primary">
                  <FaEnvelope className="text-secondary-green" />
                  <span>Contact Us</span>
                </Link>
              </div>
              <Link to="/properties" onClick={closeMobileMenu}
                className="block w-full text-center bg-secondary-green text-white font-arial-rounded py-3 px-4 rounded-site">
                Search Current Vacancies
              </Link>
            </div>
          </div>
        </nav>
      </header>
      
      {/* Adjusted spacer height for mobile */}
      
    </div>
  );
};

export default Header;